const getters = {
  loging: state => state.user.loging,
  newmessage: state => state.user.newmessage,
}
export default getters
